import React from "react";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

const CardTitleLoading: React.FC = () => {
  return (
    <Skeleton
      width={150}
      height={34}
      style={{ transform: "none", marginBottom: "6px" }}
    />
  );
};

export default CardTitleLoading;
